import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation";
import React from "react";

/**
 * Dynamically load translation files pertaining to the authentication-ui module.
 * @return {*}
 */
export default function useTranslationCommon() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/common.json'),
    'fr': import('./locales/fr/common.json')
  }), []);

  return useModuleTranslation('common', imports);
}
